var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H17C19.2091 4 21 5.79086 21 8V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V8C3 5.79086 4.79086 4 7 4H8M16 4C16 5.10457 15.1046 6 14 6H10C8.89543 6 8 5.10457 8 4M16 4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4M12 10H16M12 14H16M12 18H16",
    stroke: "#ED7F23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10C9.5 10.5523 9.05228 11 8.5 11C7.94772 11 7.5 10.5523 7.5 10C7.5 9.44772 7.94772 9 8.5 9C9.05228 9 9.5 9.44772 9.5 10Z",
    fill: "#ED7F23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.5 14.5523 9.05228 15 8.5 15C7.94772 15 7.5 14.5523 7.5 14C7.5 13.4477 7.94772 13 8.5 13C9.05228 13 9.5 13.4477 9.5 14Z",
    fill: "#ED7F23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C9.5 18.5523 9.05228 19 8.5 19C7.94772 19 7.5 18.5523 7.5 18C7.5 17.4477 7.94772 17 8.5 17C9.05228 17 9.5 17.4477 9.5 18Z",
    fill: "#ED7F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityStatus);
export default __webpack_public_path__ + "static/media/activity-status.6ecaf4ae2b29576eea701780da6d88b3.svg";
export { ForwardRef as ReactComponent };